module.exports = __webpack_public_path__ + "img/an_icon.d194c5e0.png";